import React from 'react';

const Experience = () => {
  return (
    <main className="pt-32 pb-stack-lg max-w-container-max mx-auto px-margin-page">
        {/*  Hero Header  */}
        <header className="mb-stack-lg">
            <h1 className="text-5xl md:text-6xl font-bold text-primary mb-6 tracking-tight">Professional Experience</h1>
            <p className="text-lg md:text-xl text-on-surface-variant max-w-2xl leading-relaxed">
                A chronological record of engineering complex digital ecosystems, from mission-critical national
                infrastructure to innovative IoT platforms.
            </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-gutter relative">
            {/*  Timeline Visual  */}
            <div className="hidden md:flex col-span-1 justify-center relative">
                <div className="w-0.5 timeline-line h-full absolute"></div>
            </div>
            {/*  Content Area  */}
            <div className="col-span-11 space-y-stack-lg">
                {/*  Experience Block: Applab  */}
                <article className="relative group">
                    <div
                        className="hidden md:block absolute -left-[4.5rem] top-8 w-4 h-4 rounded-full bg-primary shadow-[0_0_15px_rgba(125,211,252,0.6)] border-4 border-background z-10 transition-transform group-hover:scale-125">
                    </div>
                    <div className="glass-card p-stack-md md:p-10 rounded-xl transition-all duration-300">
                        <div className="flex flex-col md:flex-row justify-between mb-stack-md">
                            <div>
                                <span className="text-xs font-bold text-secondary tracking-widest uppercase mb-2 block">2023
                                    — Present</span>
                                <h2 className="text-3xl font-bold text-on-surface mb-1">Senior Full Stack Developer</h2>
                                <a href="https://www.applab.qa/" target="_blank" rel="noopener noreferrer" className="text-xl text-primary/90 font-medium hover:underline decoration-primary/30 underline-offset-4">Applab</a>
                            </div>
                            <div className="mt-4 md:mt-0 flex gap-2">
                                <span
                                    className="px-4 py-1.5 bg-primary/10 text-primary border border-primary/20 text-xs font-bold rounded-full h-fit">Doha,
                                    Qatar</span>
                            </div>
                        </div>
                        <div className="grid md:grid-cols-2 gap-stack-md mb-stack-md">
                            <div className="space-y-6">
                                <p className="text-on-surface-variant leading-relaxed">
                                    Leading the development of high-impact national platforms for the State of Qatar,
                                    focusing on scalability and secure architecture.
                                </p>
                                <ul className="space-y-3">
                                    <li className="flex items-start gap-3 text-sm text-on-surface-variant">
                                        <span className="material-symbols-outlined text-primary shrink-0 text-xl"
                                            data-icon="check_circle">check_circle</span>
                                        Engineered features for Metrash2, Qatar's premier government services
                                        application.
                                    </li>
                                    <li className="flex items-start gap-3 text-sm text-on-surface-variant">
                                        <span className="material-symbols-outlined text-primary shrink-0 text-xl"
                                            data-icon="check_circle">check_circle</span>
                                        Developed core modules for Qatar Rail and Hayya integration.
                                    </li>
                                </ul>
                            </div>
                            <div className="rounded-xl overflow-hidden border border-outline-variant/30 bg-surface">
                                <img
                                    alt="Government digital platform development workspace"
                                    className="w-full h-full object-cover grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-700"
                                    src="https://lh3.googleusercontent.com/aida-public/AB6AXuBRZR3Qxdky4ZcCFoxuFz1nXlaib2A0rv6MMlJszF6kotJhGYJSXP4EC8HGHWK_jUJxs75vnPoHXFUrxlDtHN_luJQ_UW4SXOy2sk9UIu516SQq9FRVCJToJ546mb6dXn8YqJBKjjBxWUWEA53AGndj_LrkSdRQAJ8xceFV13cdinEstD_YwPYw1Lu_EnT8zm_J7me3-r7_AlerpbMaaDgil--q668FF8qzvqQ4GGFX3a28slWhzgb2vJgnuVIkvNWk-DYB9eDnEG4" />
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            <span
                                className="px-3 py-1 bg-surface-container text-primary font-bold text-xs rounded border border-outline-variant/20">Strapi
                                CMS</span>
                            <span
                                className="px-3 py-1 bg-surface-container text-primary font-bold text-xs rounded border border-outline-variant/20">Volt
                                MX</span>
                            <span
                                className="px-3 py-1 bg-surface-container text-primary font-bold text-xs rounded border border-outline-variant/20">Kony</span>
                            <span
                                className="px-3 py-1 bg-surface-container text-primary font-bold text-xs rounded border border-outline-variant/20">PostgreSQL</span>
                            <span
                                className="px-3 py-1 bg-surface-container text-primary font-bold text-xs rounded border border-outline-variant/20">RESTful
                                APIs</span>
                        </div>
                    </div>
                </article>
                {/*  Experience Block: Appstation  */}
                <article className="relative group">
                    <div
                        className="hidden md:block absolute -left-[4.5rem] top-8 w-4 h-4 rounded-full bg-outline-variant border-4 border-background z-10 transition-all group-hover:bg-primary/50 group-hover:scale-125">
                    </div>
                    <div className="glass-card p-stack-md md:p-10 rounded-xl transition-all duration-300">
                        <div className="flex flex-col md:flex-row justify-between mb-stack-md">
                            <div>
                                <span
                                    className="text-xs font-bold text-on-surface-variant tracking-widest uppercase mb-2 block">2022
                                    — 2023</span>
                                <h2 className="text-3xl font-bold text-on-surface mb-1">Frontend Engineer</h2>
                                <a href="https://www.appstation.com/" target="_blank" rel="noopener noreferrer" className="text-xl text-primary/80 font-medium hover:underline decoration-primary/30 underline-offset-4">Appstation</a>
                            </div>
                        </div>
                        <p className="text-on-surface-variant mb-stack-md max-w-3xl leading-relaxed">
                            Specialized in building sophisticated user interfaces for philanthropic and automated
                            communication platforms. Spearheaded the architectural migration of legacy systems to modern
                            React-based frameworks.
                        </p>
                        <div className="grid md:grid-cols-3 gap-6 mb-stack-md">
                            <div
                                className="bg-surface-container-low p-6 border border-outline-variant/20 rounded-xl hover:border-primary/30 transition-colors">
                                <span className="material-symbols-outlined text-primary block mb-3 text-3xl"
                                    data-icon="volunteer_activism">volunteer_activism</span>
                                <h4 className="font-bold text-on-surface mb-2">Social Charity</h4>
                                <p className="text-sm text-on-surface-variant">Streamlined donation workflows and real-time
                                    impact tracking.</p>
                            </div>
                            <div
                                className="bg-surface-container-low p-6 border border-outline-variant/20 rounded-xl hover:border-primary/30 transition-colors">
                                <span className="material-symbols-outlined text-primary block mb-3 text-3xl"
                                    data-icon="forum">forum</span>
                                <h4 className="font-bold text-on-surface mb-2">AI Chatbots</h4>
                                <p className="text-sm text-on-surface-variant">Built dynamic conversational interfaces with
                                    complex state management.</p>
                            </div>
                            <div
                                className="bg-surface-container-low p-6 border border-outline-variant/20 rounded-xl hover:border-primary/30 transition-colors">
                                <span className="material-symbols-outlined text-primary block mb-3 text-3xl"
                                    data-icon="speed">speed</span>
                                <h4 className="font-bold text-on-surface mb-2">Optimization</h4>
                                <p className="text-sm text-on-surface-variant">Improved Core Web Vitals by 40% through
                                    Next.js SSR techniques.</p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Next.js</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Redux
                                Toolkit</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Tailwind
                                CSS</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Framer
                                Motion</span>
                        </div>
                    </div>
                </article>
                {/*  Experience Block: Infovision  */}
                <article className="relative group">
                    <div
                        className="hidden md:block absolute -left-[4.5rem] top-8 w-4 h-4 rounded-full bg-outline-variant border-4 border-background z-10 transition-all group-hover:bg-primary/50 group-hover:scale-125">
                    </div>
                    <div className="glass-card p-stack-md md:p-10 rounded-xl transition-all duration-300">
                        <div className="flex flex-col md:flex-row justify-between mb-stack-md">
                            <div>
                                <span
                                    className="text-xs font-bold text-on-surface-variant tracking-widest uppercase mb-2 block">2021
                                    — 2022</span>
                                <h2 className="text-3xl font-bold text-on-surface mb-1">Full Stack Developer</h2>
                                <a href="https://www.infovisionlabs.com/" target="_blank" rel="noopener noreferrer" className="text-xl text-primary/80 font-medium hover:underline decoration-primary/30 underline-offset-4">InfoVision Labs</a>
                            </div>
                        </div>
                        <div className="flex flex-col md:flex-row gap-stack-md items-center mb-stack-md">
                            <div className="w-full md:w-2/3">
                                <p className="text-on-surface-variant mb-6 leading-relaxed">
                                    Focused on enterprise-grade internal tooling and modular component libraries.
                                    Created a unified design system implemented as an internal NPM package used across
                                    multiple global teams.
                                </p>
                                <div
                                    className="bg-primary/5 p-5 rounded-xl border border-primary/20 flex items-center gap-4">
                                    <div className="bg-primary/20 p-3 rounded-lg">
                                        <span className="material-symbols-outlined text-primary text-2xl"
                                            data-icon="inventory_2">inventory_2</span>
                                    </div>
                                    <div>
                                        <p className="font-bold text-primary">UI Package Creator</p>
                                        <p className="text-sm text-on-surface-variant">Automated library publishing and
                                            semantic versioning workflows.</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="w-full md:w-1/3 bg-black/40 p-6 rounded-xl border border-primary/10 font-mono text-xs text-primary/80 overflow-x-auto">
                                <pre><code>npm install @ivl/core-ui<br/>import {"{"} Button {"}"} from '@ivl/core';<br/><br/>const App = () =&gt; (<br/>  &lt;Button variant="ghost"&gt;<br/>    Scale Enterprise<br/>  &lt;/Button&gt;<br/>);</code></pre>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">React
                                TS</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">NPM
                                Registry</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Jest</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Express.js</span>
                        </div>
                    </div>
                </article>
                {/*  Experience Block: Katomaran  */}
                <article className="relative group">
                    <div
                        className="hidden md:block absolute -left-[4.5rem] top-8 w-4 h-4 rounded-full bg-outline-variant border-4 border-background z-10 transition-all group-hover:bg-primary/50 group-hover:scale-125">
                    </div>
                    <div className="glass-card p-stack-md md:p-10 rounded-xl transition-all duration-300">
                        <div className="flex flex-col md:flex-row justify-between mb-stack-md">
                            <div>
                                <span
                                    className="text-xs font-bold text-on-surface-variant tracking-widest uppercase mb-2 block">2020
                                    — 2021</span>
                                <h2 className="text-3xl font-bold text-on-surface mb-1">Junior Full Stack Developer</h2>
                                <a href="https://www.katomaran.com/" target="_blank" rel="noopener noreferrer" className="text-xl text-primary/80 font-medium hover:underline decoration-primary/30 underline-offset-4">Katomaran Technology Business Solution</a>
                            </div>
                        </div>
                        <div className="space-y-6 mb-stack-md">
                            <p className="text-on-surface-variant leading-relaxed">
                                Kickstarted career in the IoT space, developing mobile applications that communicated
                                with hardware controllers via low-latency protocols.
                            </p>
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                <div
                                    className="text-center p-4 bg-surface-container-low rounded-xl border border-outline-variant/20 hover:border-primary/30 transition-all">
                                    <span className="material-symbols-outlined text-primary block mb-2 text-2xl"
                                        data-icon="settings_remote">settings_remote</span>
                                    <span className="text-xs font-bold text-on-surface uppercase tracking-wider">MQTT</span>
                                </div>
                                <div
                                    className="text-center p-4 bg-surface-container-low rounded-xl border border-outline-variant/20 hover:border-primary/30 transition-all">
                                    <span className="material-symbols-outlined text-primary block mb-2 text-2xl"
                                        data-icon="smartphone">smartphone</span>
                                    <span
                                        className="text-xs font-bold text-on-surface uppercase tracking-wider">Mobile</span>
                                </div>
                                <div
                                    className="text-center p-4 bg-surface-container-low rounded-xl border border-outline-variant/20 hover:border-primary/30 transition-all">
                                    <span className="material-symbols-outlined text-primary block mb-2 text-2xl"
                                        data-icon="diamond">diamond</span>
                                    <span
                                        className="text-xs font-bold text-on-surface uppercase tracking-wider">Rails</span>
                                </div>
                                <div
                                    className="text-center p-4 bg-surface-container-low rounded-xl border border-outline-variant/20 hover:border-primary/30 transition-all">
                                    <span className="material-symbols-outlined text-primary block mb-2 text-2xl"
                                        data-icon="hub">hub</span>
                                    <span className="text-xs font-bold text-on-surface uppercase tracking-wider">IoT
                                        Nodes</span>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">React
                                Native</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Rails
                                API</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Redis</span>
                            <span
                                className="px-3 py-1 bg-surface-container-highest text-tertiary font-bold text-xs rounded border border-outline-variant/20">Mosquitto</span>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </main>
  );
};

export default Experience;
